import { useEffect, useLayoutEffect } from "react";
import { isClient } from "./browser.ts";

/**
 * A hook that allows to use the useLayoutEffect hook in isomorphic React applications.
 * @param {Function} effect - The effect to be run.
 * @param {DependencyList} deps - The dependencies of the effect.
 */
const useIsomorphicLayoutEffect = isClient ? useLayoutEffect : useEffect;

export default useIsomorphicLayoutEffect;
